import styles from './styles.module.css';

type Variant = 'consent' | 'fa';
const CheckYourEmailAndPhone: React.FC<{ variant: Variant }> = ({ variant }) => {
  const variantMapping: Record<Variant, { formType: string }> = {
    ['consent']: {
      formType: 'Consent Form',
    },
    ['fa']: {
      formType: 'Financial Assistance Form',
    },
  };

  return (
    <div data-testid="check-email-and-phone" className={`${styles.emailPhoneCheckContainer}`}>
      <div className={styles.emailPhoneCheckBanner}>
        <div className={styles.statusContainer}>
          <p className={`${styles.subtitle} ${styles.emailPhoneCheckTitle}`}>
            <strong>FURTHER ACTION REQUIRED</strong>
          </p>
        </div>
        <p className={`${styles.emailPhoneCheckMessage}`}>
          To continue securely processing your {variantMapping[variant].formType} submission, we have sent a one-time
          link to your registered email address or phone number. If you are an existing Tempus patient and we do not
          have your email on file, this link was sent to the provided phone number via SMS.
        </p>
        <div>
          <p style={{ marginBottom: '0px', marginTop: '30px' }}>
            <strong>How to proceed:</strong>
          </p>
          <ol className={styles.emailPhoneCheckList}>
            <li className={`${styles.subtitle} ${styles.emailPhoneCheckListItem}`}>
              <strong>Check your email or text messages:</strong> Look for an email or SMS from Tempus containing your
              unique one-time link to complete your {variantMapping[variant].formType} submission.
            </li>
            <li className={`${styles.subtitle} ${styles.emailPhoneCheckListItem}`}>
              <strong>Click to continue:</strong> Clicking the link will open a new secure window where you can complete
              your {variantMapping[variant].formType} submission.
            </li>
            <li className={`${styles.subtitle} ${styles.emailPhoneCheckListItem}`}>
              <strong>Close this tab:</strong> Once you have clicked the link, you may safely close this browser window.
            </li>
          </ol>
        </div>
      </div>
    </div>
  );
};

export default CheckYourEmailAndPhone;
